/* istanbul ignore file */

import { Module } from 'vuex';
import { AppState } from '..';
import { Restaurant } from '@/models';
import { prefixValues } from '@/helpers/util';

export interface FindAChipotleModuleState {
  restaurantList: Restaurant[];
}

const MUTATION_NAMES = {
  SET_RESTAURANT_LIST: 'setRestaurantList',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'findAChipotle/');

export function makeFindAChipotleModule(): Module<FindAChipotleModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      restaurantList: [],
    },
    mutations: {
      [MUTATION_NAMES.SET_RESTAURANT_LIST]: (state, restaurants: Restaurant[]) => {
        state.restaurantList = restaurants;
      }
    },
  };
}
